import { useEffect } from 'react';

type RefOrRefs = React.RefObject<HTMLElement> | React.RefObject<HTMLElement>[];

export function useClickAway(refOrRefs: RefOrRefs, handler: (event: MouseEvent | TouchEvent) => void) {
  useEffect(() => {
    const refs = Array.isArray(refOrRefs) ? refOrRefs : [refOrRefs];

    const listener = (event: MouseEvent | TouchEvent) => {
      // Ignore events that were explicitly prevented by inner handlers
      // (e.g., buttons calling e.preventDefault() on mousedown to avoid stealing focus)
      if ((event as any).defaultPrevented) return;

      // If the event target is inside any of the provided refs, do nothing
      for (const r of refs) {
        if (!r || !r.current) continue;
        if (r.current.contains(event.target as Node)) return;
      }

      handler(event);
    };
    // Use pointer events for broader device support and consistency
    document.addEventListener("pointerdown", listener as any);
    document.addEventListener("touchstart", listener as any);
    return () => {
      document.removeEventListener("pointerdown", listener as any);
      document.removeEventListener("touchstart", listener as any);
    };
  }, [refOrRefs, handler]);
}